<template>
    <div class="search-keyword-center" :class="containerClass">
        <div class="title_container" v-if="inMore">
            <div class="title_mid">{{ label }}</div>
        </div>
        <div class="content">
            <im-input
                :theme="theme"
                v-model:value="modelVal"
                @enter="change"
                @blur="change"
            />
        </div>
    </div>
</template>

<script>
import classNames from 'classnames';

export default {
    name: 'SInput',
    emits: ['change'],
    props: {
        theme: {
            validator: val =>
                ['standard', 'template1', 'template4', 'broker'].includes(val),
            default: 'standard'
        },
        label: {
            // title
            type: String,
            default: ''
        },
        data: {
            type: Object,
            default: () => ({})
        },
        kee: {
            type: String,
            default: ''
        },
        inMore: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        containerClass() {
            return classNames(this.theme);
        }
    },
    data: function() {
        return {
            modelVal: ''
        };
    },
    methods: {
        change() {
            this.$emit('change', {
                kee: this.kee,
                value: this.modelVal,
                type: 'keyWord'
            });
            this.modelVal = '';
        }
    }
};
</script>

<style lang="scss">
.search-keyword-center {
    width: 100%;
    &.standard {
        color: #515666;
        font-size: 14px;
    }
    &.template1 {
        font-size: 14px;
        color: #282828;
    }
    &.template4 {
        font-size: 17px;
        color: #6b7282;
    }
    .title_container {
        margin-bottom: 10px;
    }
    .content {
        height: 40px;
        display: flex;
        align-items: center;
        justify-items: flex-start;
    }
}
</style>
